<template>
  <form class="sm-form sm-form__billing">
    <h4>Billing address</h4>
      <div class="sm-form__billing-row">
        <input-text
          v-model="formData.first_name"
          :label="'First name'"
          :name="'first_name'"
        />
        <input-text
          v-model="formData.last_name"
          :label="'Last name'"
          :name="'last_name'"
        />
      </div>

      <country-dropdown
        v-model="selectedCountry"
        :class="'sm-form__billing-label'"
        :countryList="countryList"
        :startVal="selectedCountry"
      />

      <input-text
        v-model="formData.street"
        :label="'Street'"
        :name="'street'"
        :autocomplete="`street-address`"
        v-validate="`required`"
        :error="errors.first('street')"
      />
      <input-text
        v-model="formData.city"
        :label="'City'"
        :name="'city'"
        :autocomplete="`address-level2`"
        v-validate="`required`"
        :error="errors.first('city')"
      />
      <div 
        class="sm-form__billing-row"
        :class="!stateList.length ? 'no-state' : ''"
      >
        <state-dropdown
          v-if="stateList.length > 0"
          v-model="selectedState"
          :class="'sm-form__billing-label'"
          :stateList="stateList"
          :startVal="selectedState"
        />
        <input-zip
          v-model="formData.zip"
          v-validate="'required|is_zip'"
          :country="selectedCountry"
          :name="'zip'"
          :error="errors.first('zip')"
        />
      </div>
  </form>
</template>

<script>
import FormDropdowns from '@/mixins/FormDropdowns';
import InputText from '@/components/InputText';
import InputZip from '@/components/InputZip';
import CountryDropdown from '@/components/CountryDropdown';
import StateDropdown from '@/components/StateDropdown';

export default {
  name: 'form-billing',
  components: {
    'input-text': InputText,
    'input-zip': InputZip,
    'country-dropdown': CountryDropdown,
    'state-dropdown': StateDropdown,
  },
  prop: ['value'],
  props: {
    account: {
      type: Object,
      default: () => new Object()
    }
  },
  data() {
    return {
      formData: this.$attrs.value
    };
  },
  created() {
    this.mixinUserAccount = this.account;
  },
  mixins: [FormDropdowns],
  watch: {
    formData: {
      deep: true,
      handler() {
        this.$emit('input', this.formData);
      }
    },
    'formData.first_name'() {
      this.formData.name = `${this.formData.first_name} ${this.formData.last_name}`;
    },
    'formData.last_name'() {
      this.formData.name = `${this.formData.first_name} ${this.formData.last_name}`;
    },
    selectedCountry(val) {
      this.formData.country = val;
    },
    selectedState(val) {
      if (val)
        this.formData.state = val;
      else
        delete this.formData.state;
    }
  }
}
</script>